import angular from 'angular';
import uiRouter from 'angular-ui-router';
import AuthService from './auth.service';
import HttpService from './http.service';
import NavigationService from './navigation.service';
import UsersService from './users.service';
import FilterService from './filter.service';
import NotificationService from './notification.service';
import AppContextService from './app-context.service';
import EventsService from './events.service';
import AnalyticsService from './analytics.service';
import MediaService from './media.service';
import SurveyService from './survey.service';
import ProfilesService from './profiles.service';
import CertificatesService from './certificates.service';
import ChecksService from './checks.service';
import JobsService from './jobs.service';
import JobRequestsService from './job-requests.service';
import AffiliatesService from './affiliates.service';
import VouchesService from './vouches.service';
import MermaidService from './mermaid.service';
import BotFlowService from './bot-flow.service';
import BotManagerService from './bot-manager.service';
import BotSessionsService from './bot-sessions.service';
import BusinessesService from './businesses.service';

let Services = angular.module('app.common.services', [uiRouter])

.factory('AuthService', AuthService)
.factory('HttpService', HttpService)
.factory('UsersService', UsersService)
.factory('NavigationService', NavigationService)
.factory('FilterService', FilterService)
.factory('NotificationService', NotificationService)
.factory('AppContextService', AppContextService)
.factory('EventsService', EventsService)
.factory('AnalyticsService', AnalyticsService)
.factory('MediaService', MediaService)
.factory('SurveyService', SurveyService)
.factory('ProfilesService', ProfilesService)
.factory('CertificatesService', CertificatesService)
.factory('ChecksService', ChecksService)
.factory('JobsService', JobsService)
.factory('AffiliatesService', AffiliatesService)
.factory('VouchesService', VouchesService)
.factory('MermaidService', MermaidService)
.factory('BotFlowService', BotFlowService)
.factory('BotManagerService', BotManagerService)
.factory('BotSessionsService', BotSessionsService)
.factory('BusinessesService', BusinessesService)
.factory('JobRequestsService', JobRequestsService)


export default Services;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/index.js
 **/